<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>

        <v-layout text-xs-center>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-3 align-center>
              <v-flex>
                <v-layout row>
                  <v-icon class="mr-2">fa-plus-circle</v-icon>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Create Service</div>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-form v-model="valid2" @submit="showForm" ref="formFilters">

                  <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                    <v-layout hide-details justify-start row mt-0 mb-4>

                      <v-flex hide-details mx-4>
                        <v-text-field
                          style="max-height: 45px"
                          v-model="service.AccountNumber"
                          value="AccountNumber"
                          label="Account Number*"
                          type="number"
                          :disabled="isAccountNumberDisabled"
                          required
                          :rules="accountNumberRules"
                        ></v-text-field>
                      </v-flex>

                      <v-flex hide-details mx-4 xs2>
                        <v-autocomplete
                          hide-details
                          :items="ddlElementType"
                          v-model="service.ElementType"
                          item-text="Text"
                          item-value="Value"
                          label="Element Type*"
                          :disabled="isElementTypeDisabled"
                          clearable
                          required
                          :rules="elementTypeRules"
                          @change="populateDescriptionAndServiceDlls"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex hide-details mx-4 xs2>
                        <v-autocomplete
                          hide-details
                          :items="ddlDescription"
                          v-model="service.Description"
                          item-text="Text"
                          item-value="Value"
                          label="Description*"
                          :disabled="isDescriptionDisabled"
                          clearable
                          required
                          :rules="descriptionRules"
                          @change="showForm('Description')"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex hide-details mx-4 xs2>
                        <v-autocomplete
                          hide-details
                          :items="ddlService"
                          v-model="service.Service"
                          item-text="Text"
                          item-value="Value"
                          label="Service*"
                          :disabled="isServiceDisabled"
                          clearable
                          required
                          :rules="serviceRules"
                          @change="populateProviderDll"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex hide-details mx-4 xs2>
                        <v-autocomplete
                          hide-details
                          :items="ddlProvider"
                          v-model="service.Provider"
                          item-text="Text"
                          item-value="Value"
                          label="Provider*"
                          :disabled="isProviderDisabled"
                          clearable
                          required
                          :rules="providerRules"
                          @change="showForm('Provider')"
                        ></v-autocomplete>
                      </v-flex>

                    </v-layout>
                  </v-layout>

                  <v-layout hide-details justify-end row mt-0 mb-4>
                    <a
                      class="align-center mx-4 pt-3"
                      style="text-decoration: none"
                      @click="resetFormFilters"
                    >RESET</a>
                    <!-- <v-btn
                      color="success"
                      @click="showForm()"
                      class="ml-2 mr-4"
                    >
                      Show Form
                    </v-btn> -->
                  </v-layout>

            </v-form>

            <v-divider class="mr3"></v-divider>

            <v-flex mb-0 xs12 mx-2 v-if="isPanelFormVisible">

              <v-layout justify-start row mx-3 mt-3 align-center>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Panel Service Info</div>
              </v-layout>

              <v-form v-model="valid" @submit="createPanelService" ref="createPanelServiceForm">

                    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                      <v-layout hide-details justify-start row mt-0 mb-4>

                        <v-flex hide-details mx-4 xs6>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="service.Identifier"
                            value="Identifier"
                            label="Identifier*"
                            type="number"
                            required
                            :rules="identifierRules"
                          ></v-text-field>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="service.BillPrintText"
                            value="BillPrintText"
                            label="Bill Print Text"
                            @input="forceUpperCase('BillPrintText')"
                          ></v-text-field>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="service.OrderNumber"
                            value="OrderNumber"
                            label="Order Number*"
                            @input="forceUpperCase('OrderNumber')"
                            required
                            :rules="orderNumberRules"
                          ></v-text-field>
                        </v-flex>


                        <v-flex hide-details mx-4 xs6 style="margin-top: 66px; max-height: 151px;">

                          <v-menu
                            v-model="menu"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              class="mt-0 pt-0 align-center"
                              slot="activator"
                              v-model="service.OrderDate"
                              label="Order Date*"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                              single-line
                              hide-details
                              required
                              :rules="orderDateRules"
                            ></v-text-field>
                            <v-date-picker v-model="service.OrderDate" @input="menu = false"></v-date-picker>
                          </v-menu>

                          <v-autocomplete
                            hide-details
                            :items="ddlSalesId"
                            v-model="service.SalesId"
                            item-text="Text"
                            item-value="Value"
                            label="Sales Id*"
                            clearable
                            required
                            :rules="salesIdRules"
                          ></v-autocomplete>
                        </v-flex>

                      </v-layout>
                    </v-layout>

                    <v-layout hide-details justify-end row mt-0 mb-4>
                      <!-- <a
                        class="align-center mx-4 pt-3"
                        style="text-decoration: none"
                        @click="resetCreatePanelServiceForm"
                      >RESET</a> -->
                      <v-btn
                        color="success"
                        @click="createPanelService()"
                        class="ml-2 mr-4"
                      >
                        Create
                      </v-btn>
                    </v-layout>

              </v-form>

            </v-flex>

            <!-- <v-flex mb-0 xs12 mx-2 v-if="true"> -->
            <v-flex mb-0 xs12 mx-2 v-if="isWirelessFormVisible">

              <v-layout justify-start row mx-3 mt-3 align-center>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Wireless Service Info</div>
              </v-layout>

              <v-form v-model="valid" @submit="createWirelessService" ref="createWirelessServiceForm">

                    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                      <v-layout hide-details justify-start row mt-0 mb-4>

                        <v-flex hide-details mx-4 xs4>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="service.WorkingTelNo"
                            value="WorkingTelNo"
                            :label="service.ElementType == 'MDN'?'Mobile Device Number': 'Working Tel No*'"
                            :mask="service.ElementType == 'MDN'? 'NNNNN NNNNN NNNNN NNNNN NNNNN NNNNN': '(###) ###-####'"
                            required
                            :rules="identifierRules"
                          ></v-text-field>
                          <v-text-field
                            style="max-height: 45px"
                            v-model="service.SimNo"
                            value="SimNo"
                            label="SIM No*"
                            mask="##### ##### ##### #####"
                            required
                            :rules="simNoRules"
                          ></v-text-field>
                        </v-flex>

                        <v-flex hide-details mx-4 xs4>

                          <v-autocomplete
                            hide-details
                            :items="ddlPlan"
                            v-model="service.Plan"
                            item-text="Text"
                            item-value="Value"
                            label="Plan*"
                            clearable
                            required
                            :rules="planRules"
                          ></v-autocomplete>
                          <v-autocomplete
                            hide-details
                            :items="ddlIntraRate"
                            v-model="service.LongDistance"
                            item-text="Text"
                            item-value="Value"
                            label="Long Distance*"
                            clearable
                            required
                            :rules="longDistanceRules"
                          ></v-autocomplete>
                          <v-autocomplete
                            hide-details
                            :items="ddlInterRate"
                            v-model="service.LocalRate"
                            item-text="Text"
                            item-value="Value"
                            label="Local Rate*"
                            clearable
                            required
                            :rules="localRateRules"
                          ></v-autocomplete>
                          <v-autocomplete
                            hide-details
                            :items="ddlIntlRate"
                            v-model="service.Roaming"
                            item-text="Text"
                            item-value="Value"
                            label="Roaming*"
                            clearable
                            required
                            :rules="roamingRules"
                          ></v-autocomplete>

                        </v-flex>


                        <v-flex hide-details mx-4 xs4>

                          <v-text-field
                            style="max-height: 44px"
                            v-model="service.BillPrintText"
                            value="BillPrintText"
                            label="Bill Print Text"
                            @input="forceUpperCase('BillPrintText')"
                          ></v-text-field>
                          <v-text-field
                            style="max-height: 44px"
                            v-model="service.OrderNumber"
                            value="OrderNumber"
                            label="Order Number*"
                            @input="forceUpperCase('OrderNumber')"
                            required
                            :rules="orderNumberRules"
                          ></v-text-field>

                          <v-menu
                            v-model="menu"
                            :close-on-content-click="true"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              style="max-height: 44px"
                              slot="activator"
                              v-model="service.OrderDate"
                              label="Order Date*"
                              prepend-inner-icon="fa-calendar-alt"
                              readonly
                              clearable
                              required
                              :rules="orderDateRules"
                            ></v-text-field>
                            <v-date-picker v-model="service.OrderDate" @input="menu = false"></v-date-picker>
                          </v-menu>

                          <v-autocomplete
                            hide-details
                            :items="ddlSalesId"
                            v-model="service.SalesId"
                            item-text="Text"
                            item-value="Value"
                            label="Sales Id*"
                            clearable
                            required
                            :rules="salesIdRules"
                          ></v-autocomplete>
                        </v-flex>

                      </v-layout>
                    </v-layout>

                    <v-layout hide-details justify-end row mt-0 mb-4>
                      
                      <v-btn
                        color="success"
                        @click="createWirelessService()"
                        class="ml-2 mr-4"
                      >
                        Create
                      </v-btn>
                    </v-layout>

              </v-form>

            </v-flex>

            <create1PlusService 
              v-if="is1PlusFormVisible"
              :accountNumber="service.AccountNumber"
              :elementType="service.ElementType"
              :elementDescription="service.Description"
              :serviceType="service.Service"
              :providerId="service.Provider"
               @close="close"
            ></create1PlusService>
            <create-conference-service
              v-if="isConferenceFormVisible"
              :accountNumber="service.AccountNumber"
              :elementType="service.ElementType"
              :elementDescription="service.Description"
              :serviceType="service.Service"
              :providerId="service.Provider"
              @close="close"
            ></create-conference-service>
            <create-toll-free-service
              v-if="isTollFreeFormVisible"
              :accountNumber="service.AccountNumber"
              :elementType="service.ElementType"
              :elementDescription="service.Description"
              :serviceType="service.Service"
              :providerId="service.Provider"
              @close="close"
            ></create-toll-free-service>
            <create-voice-access-service
              v-if="isVoiceAccessFormVisible"
              :accountNumber="service.AccountNumber"
              :elementType="service.ElementType"
              :elementDescription="service.Description"
              :serviceType="service.Service"
              :providerId="service.Provider"
              @close="close"
            ></create-voice-access-service>
            <create-data-access-service
              v-if="isDataAccessFormVisible"
              :accountNumber="service.AccountNumber"
              :elementType="service.ElementType"
              :elementDescription="service.Description"
              :serviceType="service.Service"
              :providerId="service.Provider"
              @close="close"
            ></create-data-access-service>
          </v-flex>
        </v-layout>

    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import Bus from "../../bus";
import moment from 'moment';
import create1PlusService from './Create1PlusService.vue'
import createConferenceService from './CreateConferenceService.vue'
import createTollFreeService from './CreateTollFreeService.vue'
import createVoiceAccessService from './CreateVoiceAccessService.vue'
import createDataAccessService from './CreateDataAccessService.vue'

export default {
  name: "CreateService",

  components: {
    create1PlusService, createConferenceService,createTollFreeService, createVoiceAccessService, createDataAccessService
  },

  data: () => ({
    dialog: false,
    valid: true,
    valid2: true,

    menu: false,

    isAccountNumberDisabled: false,
    isElementTypeDisabled: false,
    isDescriptionDisabled: true,
    isServiceDisabled: true,
    isProviderDisabled: true,

    isPanelFormVisible: false,
    isWirelessFormVisible: false,
    is1PlusFormVisible: false,
    isConferenceFormVisible:false,
    isTollFreeFormVisible:false,
    isVoiceAccessFormVisible:false,
    isDataAccessFormVisible:false,

    accountBAN: '',
    accountName: '',

    ddlElementType: [],
    ddlDescription: [],
    ddlService: [],
    ddlProvider: [],

    ddlSalesId: [],

    ddlPlan: [],
    ddlIntraRate: [],
    ddlInterRate: [],
    ddlIntlRate: [],

    accountNumberRules: [v => !!v || ""],
    elementTypeRules: [v => !!v || ""],
    descriptionRules: [v => !!v || ""],
    serviceRules: [v => !!v || ""],
    providerRules: [v => !!v || ""],

    identifierRules: [v => !!v || ""],
    orderNumberRules: [v => !!v || ""],
    orderDateRules: [v => !!v || ""],
    salesIdRules: [v => !!v || ""],

    simNoRules: [v => !!v || ""],
    planRules: [v => !!v || ""],
    longDistanceRules: [v => !!v || ""],
    localRateRules: [v => !!v || ""],
    roamingRules: [v => !!v || ""],

    service: {},

    // 1 Plus specific static data
    accountCodesItems: [
      { value: '0', text: 'None' },
      { value: '1', text: 'Unverified' },
      { value: '0', text: 'Verified' }
    ]
  }),

  mounted() {
    this.initialize();
  },

  methods: {
    initialize () {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for elements in component
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async open(item) {
      this.dialog = true;

      if (item.BAN !== 'all') {
        this.service.AccountNumber = item.BAN
        this.accountBAN = item.BAN

        this.isAccountNumberDisabled = true
      }

      this.getElementData('/api/Services/GetServicesDDLs', 'ddlElementType')

      this.getResponseData('/api/Services/GetSalesIdDDL', 'ddlSalesId')

      this.getElementData('/api/Services/GetWirelessServiceDDLs', 'ddlPlan')
      this.getElementData('/api/Services/GetWirelessServiceDDLs', 'ddlInterRate')
      this.getElementData('/api/Services/GetWirelessServiceDDLs', 'ddlIntraRate')
      this.getElementData('/api/Services/GetWirelessServiceDDLs', 'ddlIntlRate')
    },

    cancel() {
      this.dialog = false;

      this.resetFormFilters()
    },
    close(){
this.dialog = false;

      this.resetFormFilters()
      this.$root.$emit("initialize", this.paginationUpdated)
    },

    resetFormFilters() {
      this.$refs.formFilters.resetValidation()

      this.service = {}
      this.isAccountNumberDisabled = false
      this.isElementTypeDisabled = false
      this.isDescriptionDisabled = true
      this.isServiceDisabled = true
      this.isProviderDisabled = true

      this.isPanelFormVisible = false
      this.isWirelessFormVisible = false
      this.is1PlusFormVisible = false
      this.isConferenceFormVisible=false
      this.isTollFreeFormVisible=false
      this.isVoiceAccessFormVisible=false
      this.isDataAccessFormVisible=false

      if (this.accountBAN !== '') {
        this.service.AccountNumber = this.accountBAN
        this.isAccountNumberDisabled = true
      }
    },

    // resetCreatePanelServiceForm() {
    //   this.$refs.createPanelServiceForm.resetValidation()

    //   this.service.Identifier = null
    //   this.service.BillPrintText = null
    //   this.service.OrderNumber = null
    //   this.service.OrderDate = null
    //   this.service.SalesId = null
    // },

    // resetCreateWirelessServiceForm() {
    //   this.$refs.createWirelessServiceForm.resetValidation()

    //   this.service.WorkingTelNo = null
    //   this.service.SimNo = null
    //   this.service.Plan = null
    //   this.service.LongDistance = null
    //   this.service.LocalRate = null
    //   this.service.Roaming = null
    //   this.service.BillPrintText = null
    //   this.service.OrderNumber = null
    //   this.service.OrderDate = null
    //   this.service.SalesId = null
    // },

    async createPanelService() {
      if (this.$refs.createPanelServiceForm.validate()) {
        let result = await this.saveNewPanelServiceToDB()

        if (result) {
          this.$root.$emit("initialize", this.initialize);

          Bus.$emit("alert", {
            color: "success",
            message: "Service Created Successfully!"
          });
        }

        // window.location.reload();
        this.close()
      }
    },
    async saveNewPanelServiceToDB() {

      let result = await axios.post("api/Services/CreatePanelService", this.service);
      return result;
    },

    async createWirelessService() {
      if (this.$refs.createWirelessServiceForm.validate()) {
        let result = await this.saveNewWirelessServiceToDB()

        if (result) {
          this.$root.$emit("initialize", this.initialize);

          Bus.$emit("alert", {
            color: "success",
            message: "Service Created Successfully!"
          });
        }

        // window.location.reload();
        this.close()
      }
    },
    async saveNewWirelessServiceToDB() {

      let result = await axios.post("api/Services/CreateWirelessService", this.service);
      return result;
    },

    forceUpperCase(prop) {
      this.service[`${prop}`] = this.service[`${prop}`].toUpperCase()
    },

    populateDescriptionAndServiceDlls() {
      if (this.service.ElementType) {
        this.getResponseData('/api/Services/GetServiceTypeDDL/' + this.service.ElementType, 'ddlService')
        this.isServiceDisabled = false

        this.getResponseData('/api/Services/GetElementDescriptionDDL/' + this.service.ElementType, 'ddlDescription')
        this.isDescriptionDisabled = false
      } else {
        this.ddlService = []
        this.isServiceDisabled = true

        this.ddlDescription = []
        this.isDescriptionDisabled = true
      }
    },

    populateProviderDll() {
      if (this.service.ElementType && this.service.Service) {
        this.getResponseData('/api/Services/GetProviderDDL/' + this.service.Service + '/' + this.service.ElementType, 'ddlProvider')
        this.isProviderDisabled = false
      } else {
        this.ddlProvider = []
        this.isProviderDisabled = true
      }
    },

    showForm(ddlType) {
      if (ddlType === 'Provider' || (ddlType === 'Description' && this.service.Provider) ) {

        if (this.$refs.formFilters.validate()) {
          this.isAccountNumberDisabled = true
          this.isElementTypeDisabled = true
          this.isDescriptionDisabled = true
          this.isServiceDisabled = true
          this.isProviderDisabled = true

          if (this.service.Service === "CELL") {
            this.isWirelessFormVisible = true
          }

          if (this.service.Service === "PANL") {
            this.isPanelFormVisible = true
          }

          if (this.service.Service === "LDSW") {
            this.is1PlusFormVisible = true;
          }
          if (this.service.Service === "CONF"){
            this.isConferenceFormVisible=true;
          }
          if (this.service.Service === "80IS"){
            this.isTollFreeFormVisible=true;
          }
          if (this.service.Service === "LVAC"){
            this.isVoiceAccessFormVisible=true;
          }
          if (this.service.Service === "DSAC"){
            this.isDataAccessFormVisible=true;
          }
        }
      }
    },
  }
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

